import { FileUploadProgressDTO } from "@js/DTO/FileUploadProgressDTO.cs.d";
import { AuthService } from "@js/services/AuthService";
import { CaseService } from "@js/services/CaseService";
import { DevFinanceDealService } from "@js/services/Deal/DevFinanceDealService";
import { SharedDealService } from "@js/services/Deal/SharedDealService";
import { RoleService } from "@js/services/RoleService";
import { SelectListService } from "@js/services/SelectListService";
import angular from "angular";
import {
  AccountClient,
  AddressLookupDTO,
  ApplicationUser,
  ApplicationUserCrudClient,
  AppraisalModuleEnum,
  AreaUnitEnum,
  BrickflowEventLogClient,
  CaseAccessLevelEnum,
  CaseChangedMessageDTO,
  CaseLenderStateEnum,
  CaseStatusEnum,
  Client,
  DealClient,
  DealClientClient,
  DealFileAttachment,
  DealFileAttachmentClient,
  DealLender,
  DealLenderClient,
  DealNote,
  DealNoteClient,
  DealNoteCrudClient,
  DealNoteInsert,
  DealSchedule,
  DealScheduleClient,
  DevelopmentFinanceDeal,
  DevelopmentFinanceDealClient,
  DevelopmentFinanceDealCrudClient,
  EventLogEnum,
  ExternalLinks,
  ExternalLinksClient,
  InvitedUserResponse,
  Lender,
  LenderClient,
  LenderInfo,
  LenderProductTypeEnum,
  LicenseMasterStatusEnum,
  ModuleEnum,
  Organisation,
  OrganisationClient,
  OwnershipRoleEnum,
  OwnNewDevelopmentEnum,
  OwnOrPurchaseEnum,
  PlanningPermissionTypeEnum,
  PostalAddress,
  PreAgreementEnum,
  ProductFamilyEnum,
  ProductTypeEnum,
  PromoteSearchToCaseResponse,
  PropertyTypeEnum,
  SaveDevFinanceSearchRequest,
  ScheduleDescriptionTypeEnum,
  ScheduleTypeEnum,
  ShareModuleRequest,
  StreetAddressClient,
  SubmitToLendersRequest,
  TenureEnum,
  TitleEnum,
  UserSimpleDTO,
} from "@src/apis/ModularClient";
import DealHelper from "@js/helpers/DealHelper";
import { UserDashboardService } from "@js/services/UserDashboardService";
import { DealFileAttachmentHelper } from "@js/helpers/DealFileAttachmentHelper";
import { AddressHistoryDTO } from "@js/DTO/AddressHistoryDTO.cs";
import ProductHelper from "@js/helpers/ProductHelper";
import { BaseCaseController } from "@js/controllers/BaseCaseController";
import { IndexService } from "@js/services/IndexService";

interface LeaseItemDetails {
  TimeLeftOnLeaseYears?: number;
  TimeLeftOnLeaseMonths?: number;
  GrossMonthlyRentalIncome: "";
}

export class DevFinanceCaseController extends BaseCaseController<DevelopmentFinanceDeal> {
  isCaseDashboard: boolean = true;

  dataLoading: boolean;
  dealDto: DevelopmentFinanceDeal;
  tempDealDto: DevelopmentFinanceDeal;
  orgName: string;
  orgId: number;
  org: Organisation;
  fileNamePrefix: string = "Brickflow";
  newNote: DealNoteInsert = {
    deal: null,
    noteText: "",
    ownersApplicationUserGroups: [],
    ownersApplicationUsers: [],
    user: null,
    dealId: 0,
    userId: 0,
  };
  mortgageTerm: number = 0;

  CaseDashboardTypeEnum = {
    Overview: 0,
    Borrower: 1,
    Property: 2,
    Loan: 3,
    BorrowerEdit: 4,
    Planning: 5,
    BuildProcurement: 6,
    FurtherInfo: 7,
    EquityAndMezz: 8,
  };

  selectedNavMenu: number = 0;

  dealForm: ng.IFormController;
  ownershipForm: ng.IFormController;
  companyDetailsForm: ng.IFormController;
  propertyDetailsForm: ng.IFormController;
  loanDetailsForm: ng.IFormController;
  personalDetailsForm: ng.IFormController;
  contactForm: ng.IFormController;
  occupationForm: ng.IFormController;
  creditForm: ng.IFormController;
  trackRecordForm: ng.IFormController;
  salesForm: ng.IFormController;
  depositsourceForm: ng.IFormController;
  developmentScheduleForm: ng.IFormController;
  showAddressHistoryModal: boolean = false;
  planningForm: ng.IFormController;
  buildProcurementForm: ng.IFormController;
  furtherInformationForm: ng.IFormController;
  lenderDetailsForm: ng.IFormController;

  tabs = {
    tabOpen: false,
    ownership: false,
    companyDetails: false,
    personalDetails: false,
    contactDetails: false,
    occupation: false,
    credit: false,
    trackRecord: false,
  };

  loanTabs = {
    loan: false,
    depositsource: false,
    guaranteesorrecourse: false,
    exitstrategy: false,
    completion: false,
    preferences: false,
    mezzanineandequity: false,
  };

  proprtyTabs = {
    property: false,
    buildCosts: false,
    sales: false,
    developmentSchedule: false,
    planning: false,
    buildProcurement: false,
    furtherInformation: false,
  };

  ownershipType: string = "";

  leaseItems: LeaseItemDetails[] = [];

  currentApplicant: DealClient;
  tempApplicant: DealClient;
  applicantList: DealClient[] = [];

  searchterm: string;
  previousAddressSearchTerm: string;
  postCodeOptions: PostalAddress[] = [];
  previousAddressPostCodeOptions: PostalAddress[] = [];
  address: PostalAddress;
  searchingForAddress: boolean = false;
  searchingForPreviousAddress: boolean = false;
  searchresults: string = "";
  previousAddressSearchResults: string[];
  addressHistoryItem: AddressHistoryDTO;
  applicantAddressHistory: AddressHistoryDTO[] = [];

  tenureTypes = [];
  maritalStatusOptions = [];
  ownOrPurchaseOptions = [];
  ownNewDevelopmentOptions = [];
  yesNoOptions = [];
  planningOptions = [];
  titleOptions = [];
  ownershipRoleOptions = [];
  countryList = [];
  nationalityList = [];
  countryOfBirthList = [];
  countryOfResidenceList = [];
  loanCompletionTypeOptions = [];
  currentUseofBuildingOptions = [];
  loanRepaymentTypeOptions = [];
  productTypeOptions = [];
  fixedrateTermOptions = [];
  locationOptions = [];
  planningStatusAtEndOfDevOptions = [];
  planningResponsibilityOptions = [];
  buildProcurementTypeOptions = [];
  exitStrategyOptions = [];

  //modal
  message: string = "";
  modal: boolean = false;
  showErrorMessage: boolean = false;

  uploadingFiles: FileUploadProgressDTO[];
  fileUpload: DealFileAttachment[];
  applicantTrackRecordFiles: DealFileAttachment[];
  propertyFiles: DealFileAttachment[];
  total: number = 0;
  renamingFile: DealFileAttachment;

  // Number of note shown on the casedashboard
  maxNotes: number = 4;

  // Controls showing Ts & Cs when a borrower/broker submits to lenders
  showTsAndCs: boolean = false;
  showApplyTsAndCs: boolean = false;
  showTsAndCsForm: boolean = false;
  messagebool: boolean = false;
  invalidEmail: boolean = false;

  isSubmitted: boolean = false;

  isSubmittedToLenders: boolean = false;

  //Boolean to enable a re-submit button
  hasShortlistedDealLenders: boolean = false;

  caseOverview: string = "";

  selectedLendersName: string = "";
  shortlistedLendersName: string = "";

  //Sharing case
  shareContext: AppraisalModuleEnum = null;
  caseMembersWithAccess: Client[];
  showShare: boolean = false;
  selectedClientToShareWith: Client;
  shareNote: string;
  showModuleShareConfirmation: boolean;

  //show profile view
  showAppraisalPermission: boolean = false;

  //profile
  newApplicant: DealClient;

  maxDateOfBirth: Date = new Date();
  minDateOfBirth: Date = new Date("Jan 01 1900");
  maxDateForDateField: Date = new Date("Jan 01 3000");
  showAddorEdit: boolean = false;
  disableQuickEditSave: boolean = false;
  applicantForm: ng.IFormController;
  isAddShareholder: boolean = false;
  showDelete: boolean = false;
  confirmDeleteApplicant: DealClient;

  showExport: boolean = false;
  updatingName: boolean = false;
  orginalDealName: string;

  showAddHistoryConfirmDelete: boolean = false;
  addressHistoryIdToDelete: number;

  isLoggedInUser: boolean = false;

  showBridgingDeal: boolean = true;
  classUses: {} = {};

  tinymceOptions: any;
  tinymceOptionsTrackRecord: any;
  tinymceReadonlyOptions: any;
  missingAddressGaps: string[];

  ownOrPurchase: boolean;
  isFamilyInResidence: boolean;

  dateProperties = ["expiryDate"];

  profileDateProperties = [
    "dateOfBirth",
    "currentAddressFrom",
    "ukResidenceIssueDate",
    "currentEmploymentStartDate",
    "addressStartDate",
  ];

  dealDateProperties = ["originalPurchaseDate", "completionDate"];

  clientDateProperties = ["dateOfBirth"];

  maxPurchaseDate: string;
  minPurchaseDate: Date = new Date("Jan 01 1900");
  dealProductTypeDisplayText: string;
  totalGrossMonthlyRentalIncome: number = 0;
  isGrossMonthlyRentalIncomeMatch: boolean = true;
  showDeal: boolean = true;

  openTrackRecordUploadModal: boolean = false;

  //Sales section
  totalSalesCost: number;
  totalNetDevelopmentVal: number;

  //Property/property
  totalPurchaseCosts: number;
  // Property/build costs
  hasBuildCostsChanged: boolean = false;
  totalBreakdownProfessionalCosts: number;
  totalProjectCosts: number;
  buildCostPerSqFt: number;
  buildCostPerSqM: number;
  buildCostIntermediary: number;
  areaConversionFactor: number = 10.7639;
  contingencyValue: number;
  totalBuildCosts: number;
  buildCostsForm: ng.IFormController;

  //Schedule
  showUnitTypeOptions: boolean = false;
  selectedUnitType: ScheduleTypeEnum = null;
  scheduleTenureOptions = [];
  preAgreementTypeOptions = [];
  flatDescriptionTypeOptions = [];
  houseDescriptionTypeOptions = [];
  newScheduleData: DealSchedule;
  houses: DealSchedule[] = [];
  flats: DealSchedule[] = [];
  parking: DealSchedule[] = [];
  commercial: DealSchedule[] = [];
  scheduleData: DealSchedule[] = [];
  newScheduleDataPricePerUnit: number = 0;

  totalScheduleUnitsGDV: number = 0;
  totalScheduleUnitsArea: number = 0;
  tempGDV: number = 0;
  tempAreaAcquisition: number = 0;
  tempScheduleData: DealSchedule;
  showScheduleUnitDeleteConfirmation: boolean = false;
  showSuccessorFailureMessage: boolean = false;

  //Property section validity
  isPropertySectionInvalidToSave: boolean = false;

  //property for roles directive to handle referred readonly view for broker/connect broker
  isReadOnlyDeal: boolean = true;
  hasFirstLoadOccurred: boolean = false;

  referredPackagerText: string;

  properyForms = [
    "ctrl.planningForm",
    "ctrl.buildProcurementForm",
    "ctrl.furtherInformationForm",
    "ctrl.salesForm",
    "ctrl.propertyDetailsForm",
    "ctrl.buildCostsForm",
  ];

  shortListedLendersId: number[];
  lendersDetailsForSubmittoLenders: LenderInfo[];

  //SubmitToLender modal
  brokerCommission: number;
  brokerPreferredContact: string;
  isBrokerPhoneNumberUpdated: boolean = false;
  dealBrokerUser: ApplicationUser;
  totalUnreadDealLenderMessages: number = null;

  //Lender Portal Links
  dealLenders: DealLender[];
  dealLendersWithPortalLinkEnabled: DealLender[];
  lendersWithPortalLinkEnabled: Lender[];
  showLenderPortalLinks: boolean = false;
  portalLinks: {} = {};
  borrowerDetails: UserSimpleDTO;
  applicationForm: ng.IFormController;
  portalLinkDetailsAdded: {} = {};

  isDeallockerIntegrationEnabled: boolean = false;
  showMaximumApplicantsMessage: boolean = false;

  static $inject = [
    "$rootScope",
    "$routeParams",
    "$location",
    "$cookies",
    "AccountClient",
    "StreetAddressClient",
    "DevFinanceDealService",
    "DevelopmentFinanceDealClient",
    "DealNoteClient",
    "AuthService",
    "SelectListService",
    "RoleService",
    "LenderClient",
    "CaseService",
    "DealLenderClient",
    "DealFileAttachmentHelper",
    "DealFileAttachmentClient",
    "$window",
    "ExternalLinksClient",
    "DealClientClient",
    "OrganisationClient",
    "$scope",
    "$sce",
    "DealClient",
    "SharedDealService",
    "DealScheduleClient",
    "UserDashboardService",
    "DealNoteCrudClient",
    "BrickflowEventLogClient",
    "ApplicationUserCrudClient",
    "IndexService",
    "DevelopmentFinanceDealCrudClient",
  ];

  constructor(
    $rootScope: ng.IRootScopeService,
    private $routeParams: ng.route.IRouteParamsService,
    $location: ng.ILocationService,
    private $cookies: ng.cookies.ICookiesService,
    accountClient: AccountClient,
    private streetAddressClient: StreetAddressClient,
    private devFinanceDealService: DevFinanceDealService,
    private developmentFinanceDealClient: DevelopmentFinanceDealClient,
    dealNoteClient: DealNoteClient,
    private authService: AuthService,
    selectListService: SelectListService,
    roleService: RoleService,
    private lenderClient: LenderClient,
    private caseService: CaseService,
    dealLenderClient: DealLenderClient,
    private dealFileAttachmentHelper: DealFileAttachmentHelper,
    private dealFileAttachmentClient: DealFileAttachmentClient,
    private $window: ng.IWindowService,
    private externalLinksClient: ExternalLinksClient,
    private dealClientClient: DealClientClient,
    private organisationClient: OrganisationClient,
    private $scope: ng.IScope,
    private $sce: ng.ISCEService,
    dealClient: DealClient,
    sharedDealService: SharedDealService,
    private dealScheduleClient: DealScheduleClient,
    private userDashboardService: UserDashboardService,
    dealNoteCrudClient: DealNoteCrudClient,
    private eventLogClient: BrickflowEventLogClient,
    applicationUserCrudClient: ApplicationUserCrudClient,
    indexService: IndexService,
    private developmentFinanceCrudDealClient: DevelopmentFinanceDealCrudClient,
  ) {
    super(
      sharedDealService,
      indexService,
      dealNoteCrudClient,
      accountClient,
      dealNoteClient,
      dealClient,
      selectListService,
      $location,
      $rootScope,
      roleService,
      applicationUserCrudClient,
      dealLenderClient,
    );
    if ($cookies.get("access_token")) {
      this.isLoggedInUser = true;
    }
    this.maxPurchaseDate = new Date().toISOString().split("T")[0];
    this.tinymceOptionsTrackRecord = this.tinymceOptions = this.sharedDealService.tinymceOptions;
    this.tinymceOptionsTrackRecord.height = undefined;

    this.tinymceReadonlyOptions = angular.copy(this.tinymceOptions);
    this.tinymceReadonlyOptions.readonly = 1;

    if (this.$routeParams.dealId) {
      this.dataLoading = true;

      this.dealId = this.$routeParams.dealId;
      if (this.$routeParams.Promote && this.$routeParams.Promote != "null" && !this.dealDto) {
        let promote = this.$routeParams.Promote as boolean;
        this.isReadOnlyDeal = false;
        this.hasFirstLoadOccurred = true;
        if (promote) {
          this.promoteSearchToCase();
        }
      } else {
        this.dealClient
          .fetchByDealId({
            dealId: this.$routeParams.dealId,
            productFamily: ProductFamilyEnum.Development,
            isCaseDashboardCall: true,
          })
          .then((response) => {
            // The case was a pre-existing case when the broker org became a member of Connect and therefore was archived.
            if (response.devFinanceDeal.isPreConnectArchived) {
              this.$location.path("/dashboard");
            }

            //Below properties are very imp for view roles directive
            this.isReadOnlyDeal = response.isReadOnlyDealForBroker;
            this.hasFirstLoadOccurred = true;
            this.referredPackagerText = response.referredPackagerText;
            this.dealDto = response.devFinanceDeal;
            this.shortlistedLendersName = response.shortlistedLendersName;
            this.selectedLendersName = response.selectedLendersName;
            this.shortListedLendersId = response.shortlistedLendersId;
            this.totalUnreadDealLenderMessages = response.totalUnreadDealLenderMessages;

            if (this.dealDto) {
              this.orgId = this.dealDto.brokerOrganisationId;

              this.postRetrieveProcessing();

              var newShortlist = this.$routeParams.NewShortlist as boolean;
              if (newShortlist) this.getLenderPortalLinks();
            } else {
              // If no case is returned, this could be that the logged in user has been removed from the case
              // - only do this if there is a logged in user, otherwise let the routing sort out where the redirect should go
              if ((this.$rootScope as any).selectedUser) {
                this.$location.path("/dashboard");
              }
            }
          })
          .finally(() => {
            this.dataLoading = false;
          });
      }
    }

    this.countryOfBirthList = this.countryOfResidenceList = this.selectListService.GetCountries();
    this.nationalityList = this.selectListService.GetNationalities();
    this.ownOrPurchaseOptions = this.selectListService.GetOwnOrPurchase();
    this.maritalStatusOptions = this.selectListService.GetMaritalStatusOptions();
    this.ownNewDevelopmentOptions = this.selectListService.GetOwnNewDevelopmentOptions();
    this.yesNoOptions = this.selectListService.GetYesNoForBridging();
    this.titleOptions = this.selectListService.GetTitleOptions();
    this.loanCompletionTypeOptions = this.selectListService.GetLoanCompletionOptions();
    this.ownershipRoleOptions = this.selectListService.GetOwnershipRoleOptions();
    this.loanRepaymentTypeOptions = this.selectListService.GetLoanRepaymentTypeOptions();
    this.productTypeOptions = this.selectListService.GetInterestRateType();
    this.fixedrateTermOptions = this.selectListService.GetFixedRateTermOptions();
    this.locationOptions = this.selectListService.GetLocations();
    this.planningStatusAtEndOfDevOptions = this.selectListService.GetPlanningStatusAtEndOfDevelopmentOptions(ProductTypeEnum.Development);
    this.planningResponsibilityOptions = this.selectListService.GetPlanningResponsibilityOptions();
    this.buildProcurementTypeOptions = this.selectListService.GetBuildProcurementTypeOptions();
    this.exitStrategyOptions = this.selectListService.GetExitStrategyDevFinanceOptions();
    this.scheduleTenureOptions = this.selectListService.GetSceheduleTenureTypes();
    this.preAgreementTypeOptions = this.selectListService.GetPreAgreementTypes();
    this.flatDescriptionTypeOptions = this.selectListService.GetFlatDescriptionTypes();
    this.houseDescriptionTypeOptions = this.selectListService.GetHouseDescriptionTypes();
    this.getAppName();
  }

  getRequiredRoles(isCaseDashboard: boolean) {
    if (isCaseDashboard) {
      if (this.isReadOnlyDeal) {
        return `['Admin', 'Client']`;
      } else {
        return `['Admin', 'Client', 'Broker', 'Introducer']`;
      }
    }
    return `['Admin', 'Client', 'Broker', 'Introducer', 'Lender']`;
  }

  editDealName() {
    var name = this.dealDto.name;
    this.orginalDealName = name;
    this.updatingName = true;
  }

  cancelEditDealName() {
    this.updatingName = false;
    this.dealDto.name = this.orginalDealName;
  }

  postRetrieveProcessing() {
    if (this.dealDto.projectDescription) {
      this.caseOverview = this.dealDto.projectDescription;
    }

    if (this.$routeParams.selectedNavMenu) {
      this.selectedNavMenu = this.$routeParams.selectedNavMenu;
    }

    this.dealLenderClient.fetchByDealId(this.$routeParams.dealId).then((dls: DealLender[]) => {
      this.hasShortlistedDealLenders = dls.some((dl) => dl.status == CaseLenderStateEnum.Shortlisted);
    });

    //These are used for directive.
    (this.$rootScope as any).statusRequirementId = this.dealDto.id;
    this.caseService.updateCaseState(this.dealDto.id, this.dealDto.status);
    this.loadUserRolesAndDealIntegration();
    this.fileUpload = this.dealDto.attachments;
    this.applicantList = this.dealDto.dealClients;
    this.scheduleData = this.dealDto.dealSchedules;
    this.prepareUnitData();
    this.tenureTypes = this.selectListService.GetTenureTypes(this.dealDto.productType);
    this.dealProductTypeDisplayText = ProductHelper.getProductTypeDisplayText(this.dealDto.productType);
    this.currentUseofBuildingOptions = this.selectListService.GetPropertyTypes(this.dealDto.productType);
    // this.CalcTotalPurchaseCosts();

    this.buildCostPerSqFt = this.dealDto.areaUnit == AreaUnitEnum.SquareFeet ? this.dealDto.buildCostPerArea : null;
    this.buildCostPerSqM = this.dealDto.areaUnit == AreaUnitEnum.SquareMeters ? this.dealDto.buildCostPerArea : null;
    this.buildCostIntermediary = this.dealDto.buildCosts;
    this.updateBuildArea(true);
    this.calculateContingency();
    this.calculateTotalCosts();
    this.updateClassUses();

    if (this.dealDto.brokerOrganisationId) {
      this.getOrganisationbyDealId();
    }
  }

  keyPressEvent(event) {
    if (event.key === "Enter") {
      this.updatingName = false;
      this.submitForm(this.dealForm);
    }
    if (event.key === "Escape") {
      this.updatingName = false;
    }
  }

  submitForm(form: ng.IFormController = null) {
    this.dataLoading = true;

    var request: SaveDevFinanceSearchRequest = {
      clientId: null,
      deal: this.dealDto,
      shareDealDto: null,
      orgCode: "",
      enterpriseClientDto: null,
    };

    this.developmentFinanceDealClient
      .saveDevFinanceSearchReturnsId(request)
      .then((response) => {
        if (response != null) {
          this.closeTabs();
          if (form != null) form.$setPristine();
        }
      })
      .finally(() => {
        this.hasBuildCostsChanged = false;
        this.dataLoading = false;
      });
  }

  closeModalAndGoToDasboard() {
    this.showTsAndCs = false;
    this.authService.clearSelectedNavMenuAndFilterStorageData();
    this.$location.path("/userdashboard");
  }

  closeModalAndGoToDealForum() {
    this.showTsAndCs = false;
    this.$location.path("/dealforum/" + this.dealDto.id);
  }

  closeModal(test: number) {
    this.messagebool = false;
  }

  closeTabs() {
    for (let key in this.tabs) {
      this.tabs[key] = false;
    }
  }

  closeLoanTabs() {
    for (let key in this.loanTabs) {
      this.loanTabs[key] = false;
    }
  }

  discardOwnership() {
    this.dealDto.howWillYouOwnNewDevelopment = null;
    //this.companyDetails.temp = null;
    this.dealDto.excludedLenders = null;
    this.dealDto.hasTheCompanyOrPensionBeenFormedYet = null;
  }

  gotoApplicant(applicant?: DealClient) {
    this.currentApplicant = applicant || null;
    this.postCodeOptions = null;

    if (
      this.currentApplicant &&
      this.currentApplicant.profile &&
      this.currentApplicant.profile.addressHistory &&
      this.currentApplicant.profile.addressHistory.length > 0
    ) {
      this.parseAddressHistory(this.currentApplicant.profile.addressHistory);
    } else {
      this.applicantAddressHistory = [];
    }

    this.selectedNavMenu = this.CaseDashboardTypeEnum.BorrowerEdit;
    this.closeTabs();
  }

  getOwnershipTypeText(): string {
    var ownershipTypeText;

    if (this.dealDto && this.dealDto.howWillYouOwnNewDevelopment) {
      switch (this.dealDto.howWillYouOwnNewDevelopment) {
        case OwnNewDevelopmentEnum.UKLimitedCompany:
          this.ownershipType = ownershipTypeText = "Company";
          break;
        case OwnNewDevelopmentEnum.OverseasLimitedCompany:
          this.ownershipType = ownershipTypeText = "Overseas Company";
          break;
        case OwnNewDevelopmentEnum.PensionFund:
          this.ownershipType = ownershipTypeText = "Pension Fund";
          break;
        case OwnNewDevelopmentEnum.UKLimitedLiabilityPartnership:
          ownershipTypeText = "Limited Liability Partnership";
          this.ownershipType = "Partnership";
          break;
        default:
          ownershipTypeText = "";
      }
      return ownershipTypeText;
    }
    return "";
  }

  openAddressHistoryModal(addressHistory: AddressHistoryDTO = null) {
    this.previousAddressSearchResults = [];
    this.previousAddressPostCodeOptions = [];

    if (addressHistory) {
      this.addressHistoryItem = addressHistory;
    } else {
      this.addressHistoryItem = null;
    }

    this.showAddressHistoryModal = true;
  }

  addressHistoryComplete() {
    return this.sharedDealService.addressHistoryComplete(
      this.currentApplicant,
      this.applicantAddressHistory,
      this.missingAddressGaps,
    );
  }

  getAddressList(searchTerm: string, postalAddress: PostalAddress) {
    let foundMatch = false;

    if (this.postCodeOptions && this.postCodeOptions.length > 0) {
      let addressLookup = this.postCodeOptions.find((add) => {
        return add.addressLine1 + " " + add.addressLine2 === searchTerm;
      });

      if (addressLookup && !(addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;
        this.streetAddressClient.getFullAddress((addressLookup as AddressLookupDTO).id).then((address) => {
          for (let prop in address) {
            if (address.hasOwnProperty(prop)) {
              postalAddress[prop] = address[prop];
            }
          }
          this.searchterm = "";
          this.searchresults = "";
        });
      } else if (addressLookup && (addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;
        postalAddress.addressLine1 = addressLookup.addressLine2.replace(
          addressLookup.addressLine2.substring(addressLookup.addressLine2.indexOf("-") - 1),
          "",
        );
        postalAddress.addressLine2 = addressLookup.addressLine3;
        postalAddress.postCode = addressLookup.addressLine1;
        this.searchterm = "";
        this.searchresults = "";
      }
    }

    if (searchTerm.length >= 3 && !foundMatch) {
      this.searchingForAddress = true;
      this.postCodeOptions = [];

      this.streetAddressClient
        .getAddressList(searchTerm)
        .then((response) => {
          this.postCodeOptions = response;
        })
        .finally(() => {
          this.searchingForAddress = false;
        });
    }
  }

  lookupPreviousAddress(searchTerm: string) {
    let foundMatch = false;

    if (
      this.previousAddressPostCodeOptions &&
      this.previousAddressPostCodeOptions &&
      this.previousAddressPostCodeOptions.length > 0
    ) {
      let addressLookup = this.previousAddressPostCodeOptions.find((add) => {
        return add.addressLine1 + " " + add.addressLine2 === searchTerm;
      });

      if (addressLookup && !(addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;

        // We've selected an address!
        this.streetAddressClient.getFullAddress((addressLookup as AddressLookupDTO).id).then((address) => {
          this.addressHistoryItem = {
            addressLine1: address.addressLine1,
            addressLine2: address.addressLine2,
            addressLine3: address.addressLine3,
            addressLine4: address.addressLine4,
            postCode: address.postCode,
          };

          this.previousAddressSearchTerm = "";
        });
      } else if (addressLookup && (addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;
        this.addressHistoryItem = {
          addressLine1: addressLookup.addressLine2,
          addressLine2: addressLookup.addressLine3,
          addressLine3: addressLookup.addressLine4,
          addressLine4: addressLookup.postCode,
          postCode: addressLookup.addressLine1,
        };

        this.previousAddressSearchTerm = "";
      }
    }

    if (searchTerm.length >= 3 && !foundMatch) {
      this.searchingForAddress = true;
      // Initial search term
      this.previousAddressPostCodeOptions = [];

      this.streetAddressClient
        .getAddressList(searchTerm)
        .then((response) => {
          this.previousAddressPostCodeOptions = response;
        })
        .finally(() => {
          this.searchingForAddress = false;
        });
    }
  }

  saveAddressHistory(selectedApplicant: DealClient) {
    var id: number = 0;

    if (!this.applicantAddressHistory) {
      this.applicantAddressHistory = [];
    }

    // If the Id hasn't been set then this is a new previous address
    if (this.addressHistoryItem.Id == null) {
      id = this.getNextAddressHistoryId();
      this.addressHistoryItem.Id = id;
      this.applicantAddressHistory.push(this.addressHistoryItem);
    } else {
      var foundIndex = this.applicantAddressHistory
        .map(function (a) {
          return a.Id;
        })
        .indexOf(this.addressHistoryItem.Id);
      if (foundIndex > -1) {
        this.applicantAddressHistory.splice(foundIndex, 1, this.addressHistoryItem); // removed previous entry and adds the updated one in its place
      }
    }

    this.dealClientClient
      .saveAddressHistory(selectedApplicant.id, JSON.stringify(this.applicantAddressHistory))
      .then((addressHistory: string) => {
        selectedApplicant.profile.addressHistory = addressHistory;
        this.parseAddressHistory(addressHistory);
        this.showAddressHistoryModal = false;
      })
      .catch((error) => {
        this.modal = true;
        this.message = "There was a problem saving the address history. Please try again later.";
      })
      .finally(() => {
        this.showAddressHistoryModal = false;
      });
  }

  /**
   * Convert addres history JSON back to an array of PostalAddress objects
   * @param addressHistoryJson
   */
  parseAddressHistory(addressHistoryJson: string) {
    // JSON doesn't understand date types so therefore user the reviver function to manually convert them back to dates as opposed to strings
    this.applicantAddressHistory = JSON.parse(addressHistoryJson, this.sharedDealService.reviver);

    // Order the address histories by the from date (ascending)
    this.applicantAddressHistory.sort((a: AddressHistoryDTO, b: AddressHistoryDTO) => {
      return this.sharedDealService.getTime(a.FromDate) - this.sharedDealService.getTime(b.FromDate);
    });
  }

  getAddressAsString(address: PostalAddress) {
    return this.sharedDealService.getAddressAsString(address);
  }

  showConfirmAddressDelete(addressHistoryId: number) {
    this.showAddHistoryConfirmDelete = true;
    this.addressHistoryIdToDelete = addressHistoryId;
  }

  deleteAddressHistory() {
    this.showAddHistoryConfirmDelete = false;

    var foundIndex = this.applicantAddressHistory
      .map(function (a) {
        return a.Id;
      })
      .indexOf(this.addressHistoryIdToDelete);

    if (foundIndex > -1) {
      this.applicantAddressHistory.splice(foundIndex, 1);

      this.dealClientClient
        .saveAddressHistory(this.currentApplicant.id, JSON.stringify(this.applicantAddressHistory))
        .then((addressHistory: string) => {
          this.currentApplicant.profile.addressHistory = addressHistory;
          this.parseAddressHistory(addressHistory);
          this.showAddressHistoryModal = false;
        })
        .catch((error) => {
          this.modal = true;
          this.message = "There was a problem deleting the address history item. Please try again later.";
        });
    }
  }

  getNextAddressHistoryId(): number {
    return this.sharedDealService.getNextAddressHistoryId(this.applicantAddressHistory);
  }

  /** Promotes/converts a search to a case */
  promoteSearchToCase() {
    this.dealClient
      .promoteSearchToCase({ dealId: this.dealId, productFamily: ProductFamilyEnum.Development })
      .then((response: PromoteSearchToCaseResponse) => {
        if (response != null && response.devFinanceDeal != null) {
          this.dealDto = response.devFinanceDeal;
          this.shortlistedLendersName = response.shortlistedLendersName;
          this.selectedLendersName = response.selectedLendersName;
          this.shortListedLendersId = response.shortlistedLendersId;
          this.postRetrieveProcessing();
          this.loadUserRolesAndDealIntegration();
        } else {
          this.message = "Problem while promoting a search to case, please try after some time.";
          this.showErrorMessage = true;
        }
      })
      .finally(() => {
        this.dataLoading = false;
        this.getLenderPortalLinks();
      });
  }

  getLenderPortalLinks() {
    this.dealLenderClient
      .fetchByDealId(this.$routeParams.dealId)
      .then((dls: DealLender[]) => {
        this.dealLenders = dls;
        var searchChanged = this.$routeParams.SearchChanged;
        const lenderIds = dls
          .filter(
            (dl) =>
              !dl.hasAppliedInLenderPortal &&
              (dl.status === CaseLenderStateEnum.Shortlisted || searchChanged == "true"),
          )
          .map((dl) => dl.lenderId);
        return this.lenderClient.getLenderPortalLinks(lenderIds);
      })
      .then((links) => {
        this.portalLinks = links;
      })
      .catch((error) => {
        this.message = "Error fetching lender portal links: " + error;
        this.portalLinks = null;
      })
      .finally(() => {
        this.showLenderPortalLinks = Object.keys(this.portalLinks).length > 0;
      });
  }

  openPortalLink(dealLenderId: number, url: string) {
    if (!this.portalLinkDetailsAdded[dealLenderId]) {
      this.dealLenderClient
        .addLenderPortalLinkDetails(dealLenderId, this.borrowerDetails)
        .then(() => {
          this.portalLinkDetailsAdded[dealLenderId] = true;
          this.openUrl(url);
        })
        .catch((error) => {
          console.error("Error adding lender portal link details:", error);
        });
    } else {
      this.openUrl(url);
    }
  }

  private openUrl(url: string) {
    if (!/^https?:\/\//i.test(url)) {
      url = "http://" + url;
    }
    window.open(url, "_blank");
  }

  saveOverview(): void {
    this.dealDto.projectDescription = this.caseOverview;
    this.submitForm(this.dealForm);
  }

  gotoResultpage() {
    this.showErrorMessage = false;
    this.$location.path("/devfinanceresults/" + this.dealId);
  }

  onFileSelect(files: DealFileAttachment[], module: ModuleEnum) {
    if (!module) {
      module = ModuleEnum.Case;
    }

    const dealClientId = module == ModuleEnum.Track ? this.currentApplicant.id : 0;

    this.dealFileAttachmentHelper
      .UploadFileListInSync(files, this.uploadingFiles, this.dealDto.id, this.fileUpload, module, 0, dealClientId)
      .finally(() => {
        this.dataLoading = false;
      });
  }

  calculateTotalFiles(module: number) {
    if (module == ModuleEnum.Track) {
      this.total = this.fileUpload.filter(
        (item) => item.module === module && item.dealClientId == this.currentApplicant.id && !item.isDeleted,
      ).length;
    } else {
      if (this.fileUpload) {
        this.total = this.fileUpload.filter((item) => item.module === module && !item.isDeleted).length;
      }
    }

    return this.total;
  }

  calculateTotalFilesRemoving(filter: number) {
    if (this.fileUpload) {
      this.total = this.fileUpload.filter((item) => item.module != filter).length;
    }
    return this.total;
  }

  downloadFile(file: DealFileAttachment, downloadFile: boolean = false) {
    this.dataLoading = true;
    this.dealFileAttachmentClient
      .getAmazonFileAccessUri(file.fileLocation)
      .then((uri) => {
        if (downloadFile) {
          this.sharedDealService.downloadFile(uri, file.fileName);
        } else {
          this.$window.open(uri);
        }
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  renameFile(file: DealFileAttachment) {
    if (this.renamingFile === undefined) {
      // if renaming this file will dirty the case, we'll want to set it back to pristine when we're done.
      // this.renamingFileDirties = !$scope.caseForm.$dirty;
      this.renamingFile = file;
    } else {
      delete this.renamingFile;
    }
  }
  renamingFileComplete(file: DealFileAttachment) {
    this.dataLoading = true;
    this.dealFileAttachmentClient
      .fileRename(file)
      .then((response) => {
        file.tempURL = response.tempURL;
      })
      .finally(() => {
        this.dataLoading = false;
      });
    delete this.renamingFile;
  }

  renamingLinkCompleted(link: ExternalLinks) {
    this.dataLoading = true;
    this.externalLinksClient
      .addUpdate(link)
      .then((response) => {
        link.link = response.link;
      })
      .finally(() => {
        this.dataLoading = false;
      });
    delete this.renamingFile;
  }

  deleteFile(file: DealFileAttachment) {
    this.dealDto.attachments.splice(this.dealDto.attachments.indexOf(file), 1);
    this.dealFileAttachmentClient.markAsDeleted(file.id).then((result) => { }); //remove on the server
  }

  markSectionAsComplete(propertyName: string) {
    if (this.dataLoading == false) {
      this.dataLoading = true;

      this.dealDto.isLoanSectionComplete;

      this.dealClient
        .markSectionAsComplete({
          dealId: this.dealDto.id,
          propertyName: propertyName,
          productFamily: ProductFamilyEnum.Development,
        })
        .then((response) => {
          if (response) {
            this.dealDto.dealNotes.push(response.newDealNote);
            this.dealDto = response.devFinanceDeal;
          }
        })
        .finally(() => {
          this.dataLoading = false;
        });
    }
  }

  allFormsComplete(): boolean {
    if (this.dealDto) {
      if (
        this.dealDto.isBorrowerSectionComplete &&
        this.dealDto.isPropertySectionComplete &&
        this.dealDto.isLoanSectionComplete
      ) {
        return true;
      } else {
        return false;
      }
    }
  }

  /** Opens the Terms and Conditions popup when the Submit to Lenders button is clicked*/
  showTermsAndConditionsForBorrower() {
    this.showApplyTsAndCs = true;
    this.requestMessageReason = "a review";
    this.showTsAndCs = true;
  }

  /** Opens the Terms and Conditions popup when the Submit to Lenders HoT button is clicked (borrower/broker) */
  showTermsAndConditions() {
    this.dataLoading = true;
    this.lenderClient
      .getShortlistedLendersInfoForSubmitToLenders(
        LenderProductTypeEnum.DevelopmentFinance,
        true,
        this.shortListedLendersId,
      )
      .then((response) => {
        this.lendersDetailsForSubmittoLenders = response;
      })
      .finally(() => {
        this.showTsAndCs = true;
        this.showTsAndCsForm = true;
        this.dealDto.submitTsAndCs = false;
        this.invalidEmail = false;
        this.dataLoading = false;
      });
  }

  gotoLendingPage() {
    (this.$rootScope as any).isLender = false;
    this.$location.path("/dealforum/" + this.dealDto.id);
  }

  /** Submits a case to lenders */
  submitCaseToLenders() {
    this.showTsAndCsForm = false;
    this.sendingMessage = true;
    this.dataLoading = true;
    var isResubmitting = false;

    if (this.dealDto.status == CaseStatusEnum.ReadyToReSubmit) {
      isResubmitting = true;
    }

    var request = {
      dealId: this.dealId,
      productType: this.dealDto.productType,
      resubmitToLenders: isResubmitting,
      brokerCommission: Number(this.brokerCommission),
      lendersInfo: this.lendersDetailsForSubmittoLenders,
      brokerPhoneNumber: this.brokerPreferredContact,
      isBrokerPhoneNumberUpdated: this.isBrokerPhoneNumberUpdated,
    } as SubmitToLendersRequest;

    this.dealClient
      .submitToLenders(request)
      .then((response: CaseChangedMessageDTO) => {
        this.dealDto.status = response.caseState;
        this.caseService.updateCaseState(this.dealDto.id, response.caseState);
        this.showMessage("You have requested a Decision in Principle from each lender.");
        this.isSubmittedToLenders = true;
      })
      .catch((error) => {
        this.showMessage("Sorry, something went wrong. Please try again.");
      })
      .finally(() => {
        this.sendingMessage = false;
        this.dataLoading = false;
      });
  }

  validateEmails() {
    this.invalidEmail = false;

    angular.forEach(this.lendersDetailsForSubmittoLenders, (lenderdetails, index) => {
      var emailField = this.lenderDetailsForm["email" + index];

      if (emailField && emailField.$invalid) {
        this.invalidEmail = true;
      }
    });
  }

  requestEmail(reason): void {
    this.showRequestEmailForm = true;
    this.requestMessageReason = reason;
    this.messagebool = true;
    this.messageContent = "";
  }

  getAppName() {
    let lsd = sessionStorage.getItem("applicationName");
    if (lsd != null) {
      this.appName = lsd;
    } else {
      this.appName = "Brickflow";
    }
  }

  closeConfirmationModal() {
    if (this.isSubmittedToLenders) {
      if (this.$routeParams.Promote) {
        this.$location.path("/devfinancecasedashboard/" + this.dealDto.id);
      } else {
        window.location.reload();
      }
    }
    this.showTsAndCs = false;
  }

  viewResults() {
    this.$location.path("/devfinanceresults/" + this.dealDto.id);
  }

  /** Process the Heads of Terms button being clicked */
  headsOfTermsClicked() {
    sessionStorage.setItem("lenderTask", "terms");
    this.$location.path("/devfinanceheadsofterm/" + this.dealDto.id + "/" + this.dealLender.id);
  }

  /** Lender rejects the case*/
  rejectButtonClicked() {
    sessionStorage.setItem("lenderTask", "reject");
    this.$location.path("/devfinanceheadsofterm/" + this.dealDto.id + "/" + this.dealLender.id);
  }

  withDrawButtonClicked() {
    sessionStorage.setItem("lenderTask", "withdraw");
    this.$location.path("/devfinanceheadsofterm/" + this.dealDto.id + "/" + this.dealLender.id);
  }

  feedbackButtonClicked() {
    sessionStorage.setItem("lenderTask", "feedback");
    this.$location.path("/devfinanceheadsofterm/" + this.dealDto.id + "/" + this.dealLender.id);
  }

  //Share module functions
  openShareModuleModal(contextToShare: AppraisalModuleEnum) {
    this.shareContext = contextToShare;
    this.constructShareNoteMessage();

    this.dealClientClient.fetchDealMembersWithAccess(this.dealDto.id).then((response: Client[]) => {
      this.caseMembersWithAccess = response;

      this.showShare = true;
    });
  }

  sendToBorrower() {
    this.dataLoading = true;

    var request = {
      clientFirstName: this.selectedClientToShareWith.firstName,
      clientLastName: this.selectedClientToShareWith.lastName,
      clientEmail: this.selectedClientToShareWith.email,
      note: this.shareNote,
      dealId: this.dealDto.id,
      section: this.shareContext,
      productFamily: ProductFamilyEnum.Development,
    } as ShareModuleRequest;

    this.dealClient.shareModuleToBorrower(request).then((success) => {
      if (success) {
        this.showShare = false;
        this.dataLoading = false;
        this.showModuleShareConfirmation = true;
        this.selectedClientToShareWith = null;
      } else {
        this.showShare = false;
        this.showMessage("Sorry, something went wrong. Please try again.");
      }
    });
  }

  isShareNoteFormComplete(): boolean {
    return this.selectedClientToShareWith && this.shareNote && this.shareNote.length > 0 ? true : false;
  }

  //End of Share module functions

  // Profile view functions

  /**
   * Show the Add/Edit permissions profile modal
   * @param applicant
   */
  showPermissionsProfileModal(profile: DealClient = null, isEdit: boolean = null): void {
    this.showMaximumApplicantsMessage = false;

    if (isEdit) {
      this.newApplicant = profile;
      this.isAddShareholder = false;
      this.showAddorEdit = true;
    } else {
      this.newApplicant = {} as DealClient;
      this.isAddShareholder = true;
      this.newApplicant.accessLevel = CaseAccessLevelEnum.Hidden;
      this.showAddorEdit = true;
    }
  }

  resetApplicant() {
    this.applicantForm.$setPristine();
    this.applicantForm.$setUntouched();
    this.newApplicant = {} as DealClient;
    this.showAddorEdit = false;
  }

  /**
   * Saves the applicant being added/edited
   */
  saveApplicant(formController) {
    this.dataLoading = true;

    if (!(this.currentApplicant.id > 0)) {
      this.currentApplicant.isApplicant = true;
      this.currentApplicant.dealId = this.dealDto.id;
      this.currentApplicant.accessLevel = CaseAccessLevelEnum.Hidden;
    }

    this.currentApplicant.uniqueRef = this.currentApplicant.uniqueRef ?? '';
    this.currentApplicant.accessLevel = this.currentApplicant.accessLevel ?? CaseAccessLevelEnum.Hidden;
    this.currentApplicant.ownershipPercentage = this.currentApplicant.ownershipPercentage ?? 0;
    this.currentApplicant.ownershipRole = this.currentApplicant.ownershipRole ?? OwnershipRoleEnum.None;
    this.currentApplicant.client = this.currentApplicant.client ?? {
      firstName: "",
      lastName: "",
      phoneNumber: "",
      email: "",
      postalAddress: {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        postCode: "",
      },
    } as Client;;
    this.currentApplicant.deal = this.currentApplicant.deal ?? null;

    this.saveUpdatedApplicant(this.currentApplicant, false, formController);
  }

  /**
   * Add or update a applicant
   * @param applicant
   */
  saveUpdatedApplicant(applicant: DealClient, isPermissionsProfile: boolean = false, formController = null): void {
    this.dataLoading = true;

    this.disableQuickEditSave = true; // this is just because sometimes the save takes a little while and the user could click the save button again
    applicant.dealId = this.dealDto.id;

    //Below code is added for upgrade
    if (!(applicant.id > 0)) {
      applicant.deal = null;
      applicant.clientId = 0;
    }

    if (applicant.client) {
      applicant.client.phoneNumber ??= "";
      applicant.client.email ??= "";

      if (applicant.client.postalAddress != null) {
        applicant.client.postalAddress.addressLine1 ??= "";
        applicant.client.postalAddress.addressLine2 ??= "";
        applicant.client.postalAddress.addressLine3 ??= "";
        applicant.client.postalAddress.addressLine4 ??= "";
        applicant.client.postalAddress.postCode ??= "";
      }
    }
    // End of upgrade changes
    if (applicant) {
      this.dateProperties.forEach((property) => {
        let val = applicant[property];
        if (val) {
          applicant[property] = this.modifyDateForBackend(val);
        }
      });
    }

    if (applicant.profile) {
      this.profileDateProperties.forEach((property) => {
        let val = applicant.profile[property];
        if (val) {
          applicant.profile[property] = this.modifyDateForBackend(val);
        }
      });

      if (applicant.profile.postalAddress == null) {
        applicant.profile.postalAddress = {
          addressLine1: "",
          addressLine2: "",
          addressLine3: "",
          addressLine4: "",
          postCode: "",
        };
      }
      applicant.profile.profileUsers = applicant.profile.profileUsers ?? [];
      applicant.profile.qualifications = applicant.profile.qualifications ?? [];
      applicant.profile.assetLiabilityItems = applicant.profile.assetLiabilityItems ?? [];
    }

    if (applicant.client) {
      this.clientDateProperties.forEach((property) => {
        let val = applicant.client[property];
        if (val) {
          applicant.client[property] = this.modifyDateForBackend(val);
        }
      });

      if ((!applicant.client?.postalAddress && isPermissionsProfile) ||
        (!this.isAddShareholder && !applicant.client?.postalAddress && !applicant.id)) {
        applicant.client.postalAddress = {
          addressLine1: "",
          addressLine2: "",
          addressLine3: "",
          addressLine4: "",
          postCode: "",
        };
      }
    }

    this.dealClientClient
      .addorUpdateApplicant(this.isAddShareholder, applicant)
      .then((response) => {
        this.dataLoading = true;

        if (response) {
          this.dateProperties.forEach((property) => {
            let val = response[property];
            if (val) {
              response[property] = this.modifyDateForFrontend(val);
            }
          });
        }

        if (response.profile) {
          this.profileDateProperties.forEach((property) => {
            let val = response.profile[property];
            if (val) {
              response.profile[property] = this.modifyDateForFrontend(val);
            }
          });
        }

        if (response.client) {
          this.clientDateProperties.forEach((property) => {
            let val = response.client[property];
            if (val) {
              response.client[property] = this.modifyDateForFrontend(val);
            }
          });
        }

        const existingShareholder = this.applicantList.find((s) => s.id == response.id);

        // If found then we're updating
        if (existingShareholder) {
          this.applicantList = this.applicantList.filter((member) => member.id != applicant.id);
          this.applicantList.push(response);
        } else {
          this.applicantList.push(response);
        }
        if (!isPermissionsProfile) {
          this.currentApplicant = response;
          formController.$setPristine();
        }
      })
      .finally(() => {
        delete this.newApplicant;
        this.showAddorEdit = false;
        this.disableQuickEditSave = false;
        this.dataLoading = false;
      });
  }

  cancelUpdateApplicant() {
    this.showAddorEdit = false;
    this.applicantList = this.applicantList.filter((applicant) => applicant.id != this.newApplicant?.id);
    this.applicantList.push(this.newApplicant); // Resets anything that is changed using the original data object
  }

  deleteApplicant(): void {
    this.dataLoading = true;
    this.dealClientClient
      .markAsDeleteAndSetNextApplicantAsPrimary(this.dealDto.id, this.confirmDeleteApplicant.id)
      .then((response) => {
        this.applicantList = response;
      })
      .finally(() => {
        this.dataLoading = false;
        this.confirmDeleteApplicant = {} as DealClient;
        this.showDelete = false;
      });
  }

  deleteConfirmApplicant(applicant: DealClient) {
    this.showDelete = true;
    this.confirmDeleteApplicant = applicant;
  }

  nonUkWarningVisible(): boolean {
    return this.sharedDealService.nonUkWarningVisible(this.currentApplicant);
  }

  showInviteButton(shareholder: DealClient) {
    return this.sharedDealService.showInviteButton(shareholder);
  }

  invite(applicant: DealClient) {
    this.dataLoading = true;

    this.dealClientClient
      .inviteApplicant(applicant.uniqueRef)
      .then((i) => {
        this.modal = true;
        this.message =
          "A request has been sent to " +
          applicant.client.firstName +
          " " +
          applicant.client.lastName +
          " complete their shareholder profile.";
      })
      .catch((error) => {
        this.modal = true;
        this.message =
          "There was a problem sending the invite request to " +
          applicant.client.firstName +
          " " +
          applicant.client.lastName +
          ". Please try again later.";
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  //End of Profile view functions

  /** Show and hide the export menu */
  showAndHideExport() {
    this.showExport = !this.showExport;
  }

  modifyDateForBackend(property: Date) {
    return this.sharedDealService.modifyDateForBackend(property);
  }

  modifyDateForFrontend(property: Date) {
    return this.sharedDealService.modifyDateForFrontend(property);
  }

  disablePersonalDetails() {
    return this.sharedDealService.disablePersonalDetails(this.currentApplicant, this.personalDetailsForm);
  }

  goToUserDashboard() {
    this.authService.clearSelectedNavMenuAndFilterStorageData();
    this.$location.path("/userdashboard");
  }

  // Setting the dependent data when option are changed
  clearSearchdata() {
    this.dealDto = this.devFinanceDealService.clearSearchdata(this.dealDto);
  }

  datasetupOnOwnOrPurchaseChange() {
    this.dealDto = this.devFinanceDealService.datasetupOnOwnOrPurchaseChange(this.dealDto);
  }

  datasetupOnIsTenantedBuildingChange() {
    if (!this.dealDto.isTenantedBuilding) this.leaseItems = null;
    this.dealDto = this.devFinanceDealService.datasetupOnIsTenantedBuildingChange(this.dealDto);
  }

  datasetupOnMaxLoanRequiredChange() {
    this.dealDto = DealHelper.dataSetupOnMaxLoanRequiredChange(this.dealDto);
  }

  onPropertyTabSelection() {
    if (this.dealDto) {
      this.selectedNavMenu = this.CaseDashboardTypeEnum.Property;

      this.propertyFiles = this.fileUpload.filter((item) => item.module === ModuleEnum.Property);

      this.onTabSelection();
    }
  }

  discardDealData(form: ng.IFormController = null) {
    event.stopPropagation();
    if (form == this.propertyDetailsForm) {
      this.dealDto = JSON.parse(JSON.stringify(this.tempDealDto));
      this.postCodeOptions = [];
      this.searchterm = null;
    } else {
      this.dealDto = JSON.parse(JSON.stringify(this.tempDealDto));
    }

    if (form) {
      form.$setPristine();
      form.$setUntouched();
    }
  }

  onLoanTabSelection() {
    if (this.dealDto) {
      this.selectedNavMenu = this.CaseDashboardTypeEnum.Loan;
      this.closeLoanTabs();
      this.onTabSelection();
    }
  }

  onPlanningTabSelection() {
    if (this.dealDto) {
      this.selectedNavMenu = this.CaseDashboardTypeEnum.Planning;
      this.onTabSelection();
    }
  }

  onBuildProcurementTabSelection() {
    if (this.dealDto) {
      this.selectedNavMenu = this.CaseDashboardTypeEnum.BuildProcurement;
      this.onTabSelection();
    }
  }

  onFurtherInfoTabSelection() {
    if (this.dealDto) {
      this.selectedNavMenu = this.CaseDashboardTypeEnum.FurtherInfo;
      this.onTabSelection();
    }
  }

  onTabSelection() {
    this.tempDealDto = JSON.parse(JSON.stringify(this.dealDto));
  }

  discardApplicantData(form: ng.IFormController) {
    event.stopPropagation();
    this.currentApplicant = JSON.parse(JSON.stringify(this.tempApplicant));
    form.$setPristine();
    form.$setUntouched();
  }

  onApplicantTabSelection(tab) {
    if (tab != "trackRecord" || (tab == "trackRecord" && this.currentApplicant)) {
      const str = tab;
      this.tabs[str] = !this.tabs[str];

      this.tempApplicant = JSON.parse(JSON.stringify(this.currentApplicant));
    }
  }

  onPropertySubTabSelection(tab) {
    const str = tab;
    this.proprtyTabs[str] = !this.proprtyTabs[str];
    this.onTabSelection();
  }

  onLoanSubTabSelection(tab) {
    const str = tab;
    this.loanTabs[str] = !this.loanTabs[str];
    this.onTabSelection();
  }

  carriageReturnCheck(event) {
    if (event.key === "Enter") {
      let position = event.target.selectionStart;
      if (this.newNote.noteText) {
        this.newNote.noteText = [
          this.newNote.noteText.slice(0, position),
          "\n",
          this.newNote.noteText.slice(position),
        ].join("");

        setTimeout(() => {
          event.target.setSelectionRange(position + 1, position + 1);
        }, 0);
      } else {
        this.newNote.noteText = "\n";
      }
    }
  }

  trustedHtml(plainText) {
    return this.$sce.trustAsHtml(plainText);
  }

  initialiseTitleAndTitleOption() {
    if (this.currentApplicant?.profile) {
      const { title, titleOption } = this.currentApplicant.profile;

      // If TitleOption has a value greater than 0, set Title to null
      if ((titleOption > TitleEnum.None && titleOption != TitleEnum.Other) || title == null) {
        this.currentApplicant.profile.title = "";
      }
      // If Title exists and TitleOption is not set, set TitleOption to Other
      else if (title && !titleOption) {
        this.currentApplicant.profile.titleOption = TitleEnum.Other;
      }
    }
  }

  onTitleOptionChange() {
    const { titleOption } = this.currentApplicant.profile;

    if (titleOption > 0 && titleOption != TitleEnum.Other) {
      this.currentApplicant.profile.title = "";
    }
  }

  onIsMortgagedChange() {
    if (!this.dealDto.isMortgaged) {
      this.dealDto.mortgageCurrentLender = null;
      this.dealDto.mortgageCurrentBalance = 0;
    }
  }

  goToLoanTypeSelectionPage() {
    if (this.isLoggedInUser) {
      this.authService.setHasValidStatustoShowShareSearchModal(true);
    }
    this.$location.path("/allloans");
  }

  propertySaveDisabled() {
    var commonFields = [
      this.dealDto.ownOrPurchase,
      this.dealDto.locations,
      this.dealDto.isFamilyInResidence,
      this.dealDto.propertyAddress.addressLine1,
      this.dealDto.propertyAddress.postCode,
      this.dealDto.purchasePrice,
      this.dealDto.stampDutyLandTax,
      this.dealDto.purchaseLegalFees,
      this.dealDto.payingVATOnLandPurchase,
    ];

    if (this.dealDto.isMortgaged) {
      commonFields.push(this.dealDto.mortgageCurrentLender);
      commonFields.push(this.dealDto.mortgageCurrentLender);
    }

    if (this.dealDto.ownOrPurchase == OwnOrPurchaseEnum.Own) {
      commonFields.push(this.dealDto.currentvalue);
      commonFields.push(this.dealDto.landTotalOtherCosts);
    }

    if (this.dealDto.ownOrPurchase == OwnOrPurchaseEnum.Purchasing) {
      commonFields.push(this.dealDto.purchaseCosts);
    }

    if (this.dealDto.payingVATOnLandPurchase === 1) {
      commonFields.push(this.dealDto.landPurchaseVatAmount);
    }

    if (this.propertyDetailsForm && this.propertyDetailsForm.$invalid) return true;

    for (let i = 0; i < commonFields.length; i++) {
      if (commonFields[i] == null || commonFields[i] == "0" || commonFields[i] == "") {
        return true;
      }
    }

    return false;
  }

  planningSaveDisabled() {
    var selectFields = [this.dealDto.planningStatusAtEndOfLoan, this.dealDto.planningResponsibility];

    if (this.planningForm.$invalid) return true;

    for (let i = 0; i < selectFields.length; i++) {
      if (selectFields[i] === 0 || selectFields[i] === PlanningPermissionTypeEnum.None) {
        return true;
      }
    }

    return false;
  }

  buildProcurementSaveDisabled() {
    var selectFields = [this.dealDto.buildProcurementType];

    if (this.buildProcurementForm.$invalid) return true;

    for (let i = 0; i < selectFields.length; i++) {
      if (selectFields[i] === null) {
        return true;
      }
    }

    return false;
  }

  /**
   * Convert LeaseDeatails JSON back to an array of LeaseDeatails objects
   * @param leaseItemsJson
   */
  parseLeaseDetails(leaseItems: string) {
    if (leaseItems != null && leaseItems.length > 0) {
      // JSON doesn't understand date types so therefore user the reviver function to manually convert them back to dates as opposed to strings
      this.leaseItems = JSON.parse(leaseItems, this.sharedDealService.reviver);
    }
  }

  initMortgageTerm() {
    this.dealDto.loanTermReq = this.dealDto.loanTermReq || 240;
    this.mortgageTerm = this.dealDto.loanTermReq / 12;
  }

  mortgageTermToLoanTerm() {
    this.dealDto.loanTermReq = this.mortgageTerm * 12;
  }

  /**
   * Calculates the order number of all the preferences when one is toggled
   * @param toggledPreference
   */
  calculatePreferenceOrder(toggledPreference: string) {
    const preferenceNames = [
      "searchPreferenceLoanSize",
      "searchPreferencePricing",
      "searchPreferenceCompletionSpeed",
      "searchPreferenceCustomerService",
    ];
    // Finds the highest preference order of all preferences
    const maxPreferenceOrder = Math.max(
      this.dealDto.searchPreferenceCompletionSpeed,
      this.dealDto.searchPreferenceCustomerService,
      this.dealDto.searchPreferenceLoanSize,
      this.dealDto.searchPreferencePricing,
    );

    // If the preference that has been toggled already has a value greater than 0 then it is being turned OFF
    if (this.dealDto[toggledPreference] > 0) {
      // Find any preferences that have a higher preference number and decrease their order number by 1
      for (let preference of preferenceNames) {
        if (preference == toggledPreference) {
          continue;
        } else {
          if (this.dealDto[preference] > this.dealDto[toggledPreference]) {
            this.dealDto[preference]--;
          }
        }
      }

      this.dealDto[toggledPreference] = 0;
    } else {
      // Preference is being turned ON
      // Use the highest preference order number and increase by 1
      this.dealDto[toggledPreference] = maxPreferenceOrder + 1;
    }
  }

  CalcNDV(): number {
    if (this.dataLoading === false) {
      var gdv: number = 0;
      var sales: number = 0;

      if (this.dealDto.gdv) {
        gdv = Number(this.dealDto.gdv);
      }

      if (this.totalSalesCost) {
        sales = Number(this.totalSalesCost);
      }

      var ndv: number = Number(gdv - sales);

      if (ndv <= 0) {
        ndv = 0;
      }

      this.totalNetDevelopmentVal = ndv;
      return ndv;
    }
  }

  CalcTotalSalesCost(): number {
    if (this.dataLoading === false) {
      var res: number = 0;
      if (this.dealDto.salesAgentFees) {
        res += Number(this.dealDto.salesAgentFees);
      }
      if (this.dealDto.salesLegalFees) {
        res += Number(this.dealDto.salesLegalFees);
      }
      this.totalSalesCost = res;
      return res;
    }
  }

  CalcTotalPurchaseCosts(): number {
    var res: number = 0;
    if (this.dealDto.purchasePrice) {
      res += Number(this.dealDto.purchasePrice);
    }
    if (this.dealDto.stampDutyLandTax) {
      res += Number(this.dealDto.stampDutyLandTax);
    }
    if (this.dealDto.purchaseLegalFees) {
      res += Number(this.dealDto.purchaseLegalFees);
    }
    if (this.dealDto.purchaseCosts) {
      res += Number(this.dealDto.purchaseCosts);
    }

    if (this.dealDto.payingVATOnLandPurchase === 1) {
      res += Number(this.dealDto.landPurchaseVatAmount);
    }

    this.totalPurchaseCosts = res;
    return res;
  }

  onOwnOrPurchaseChange(OwnOrPurchase: boolean) {
    this.dealDto.ownOrPurchase = this.dealDto.hasOwnOrPurchase ? OwnOrPurchaseEnum.Own : OwnOrPurchaseEnum.Purchasing;
    //TODO need a review for this function
    this.datasetupOnOwnOrPurchaseChange();
  }

  updateVatOnLandPurchase(PayingVATOnLandPurchase): void {
    this.dealDto.payingVATOnLandPurchase = PayingVATOnLandPurchase;
    if (this.dealDto.payingVATOnLandPurchase === 1) {
      //if yes, show vat amount question prepopulated with 20% of purchase price
      this.dealDto.landPurchaseVatAmount = this.dealDto.purchasePrice * 0.2;
      this.CalcTotalPurchaseCosts();
    }
  }

  toggleHasProfessionalCostsBreakdown(hasProfessionalCostsBreakdown: boolean) {
    this.dealDto.hasProfessionalCostsBreakdown = hasProfessionalCostsBreakdown;

    if (!this.dealDto.hasProfessionalCostsBreakdown) {
      this.dealDto.planningCosts = null;
      this.dealDto.projectManagementCosts = null;
      this.dealDto.s106CILCosts = null;
      this.dealDto.clientQSCosts = null;
      this.dealDto.mechanicalEngineeringCosts = null;
      this.dealDto.structuralEngineeringCosts = null;
      this.dealDto.partyWallCosts = null;
      this.dealDto.warrantyCosts = null;
      this.dealDto.landscapingCosts = null;
      this.dealDto.otherProfessionalCosts = null;
      this.dealDto.otherProfessionalCostsDescription = "";
    }
    this.calculateTotalCosts();
  }

  calculateTotalCosts() {
    var totalCosts: number = 0;

    if (this.dealDto.hasProfessionalCostsBreakdown) {
      if (this.dealDto.planningCosts) {
        totalCosts += Number(this.dealDto.planningCosts);
      }

      if (this.dealDto.projectManagementCosts) {
        totalCosts += Number(this.dealDto.projectManagementCosts);
      }

      if (this.dealDto.s106CILCosts) {
        totalCosts += Number(this.dealDto.s106CILCosts);
      }

      if (this.dealDto.clientQSCosts) {
        totalCosts += Number(this.dealDto.clientQSCosts);
      }

      if (this.dealDto.mechanicalEngineeringCosts) {
        totalCosts += Number(this.dealDto.mechanicalEngineeringCosts);
      }

      if (this.dealDto.structuralEngineeringCosts) {
        totalCosts += Number(this.dealDto.structuralEngineeringCosts);
      }

      if (this.dealDto.partyWallCosts) {
        totalCosts += Number(this.dealDto.partyWallCosts);
      }

      if (this.dealDto.warrantyCosts) {
        totalCosts += Number(this.dealDto.warrantyCosts);
      }

      if (this.dealDto.landscapingCosts) {
        totalCosts += Number(this.dealDto.landscapingCosts);
      }

      if (this.dealDto.otherProfessionalCosts) {
        totalCosts += Number(this.dealDto.otherProfessionalCosts);
      }

      if (this.dealDto.demolitionCosts) {
        totalCosts += Number(this.dealDto.demolitionCosts);
      }
    } else {
      totalCosts += Number(this.dealDto.additionalOngoingCosts);
    }

    if (totalCosts != 0) this.totalBreakdownProfessionalCosts = totalCosts;

    this.totalProjectCosts = Number(this.totalBuildCosts) + totalCosts + Number(this.dealDto.purchasePrice);

    if (this.dealDto.marketingCosts) {
      this.totalProjectCosts += Number(this.dealDto.marketingCosts);
    }
  }

  updateBuildArea(initial: boolean = false) {
    if (this.dealDto.areaUnit == AreaUnitEnum.SquareFeet) {
      this.dealDto.buildCostPerArea = this.buildCostPerSqFt;
      this.buildCostPerSqM = Number(this.convertSqFtToSqM(this.buildCostPerSqFt).toFixed(2));
    } else {
      this.dealDto.buildCostPerArea = this.buildCostPerSqM;
      this.buildCostPerSqFt = Number(this.convertSqMToSqFt(this.buildCostPerSqM).toFixed(2));
    }
    if (!initial) {
      this.calculateBuildCostIntermediary();
    }
  }

  convertSqMToSqFt(costPerSqM: number): number {
    return costPerSqM / this.areaConversionFactor;
  }

  convertSqFtToSqM(costPerSqFt: number): number {
    return costPerSqFt * this.areaConversionFactor;
  }

  calculateBuildCostIntermediary() {
    if (this.dealDto.grossInternalAreaKnown && this.dealDto.buildCostPerArea > 0 && this.dealDto.areaAcquisition > 0) {
      this.buildCostIntermediary = this.dealDto.areaAcquisition * this.dealDto.buildCostPerArea;
    }
    this.calculateContingency();
  }

  updateGIA() {
    this.calculateBuildCostIntermediary();
  }

  updateContingency() {
    this.calculateContingency();
  }

  toggleKnowsGIA() {
    this.dealDto.grossInternalAreaKnown = !this.dealDto.grossInternalAreaKnown;
    if (this.dealDto.grossInternalAreaKnown == true) {
      this.dealDto.areaUnit = AreaUnitEnum.SquareFeet;
    } else {
      this.dealDto.areaAcquisition = null;
      this.dealDto.areaUnit = null;
      this.buildCostPerSqFt = null;
      this.buildCostPerSqM = null;
      this.dealDto.buildCostPerArea = null;
    }

    this.buildCostIntermediary = null;
    this.buildCostsForm.buildCostIntermediary.$setUntouched();
    this.updateContingency();
  }

  calculateContingency() {
    if (this.dealDto.includesContingency) {
      this.contingencyValue =
        this.buildCostIntermediary - this.buildCostIntermediary / (1 + Number(this.dealDto.contingency));
    } else {
      this.contingencyValue = this.buildCostIntermediary * this.dealDto.contingency;
    }
    this.calculateTotalBuildCost();
  }

  calculateTotalBuildCost() {
    if (this.dealDto.includesContingency) {
      this.totalBuildCosts = this.buildCostIntermediary;
      this.dealDto.buildCosts = Number(this.buildCostIntermediary) - this.contingencyValue;
    } else {
      this.totalBuildCosts = Number(this.buildCostIntermediary) + this.contingencyValue;
      this.dealDto.buildCosts = Number(this.buildCostIntermediary);
    }

    this.calculateTotalCosts();
  }

  /** Schedule */
  showOrHideUnitTypeOptions() {
    this.showUnitTypeOptions = !this.showUnitTypeOptions;
  }

  onSelectingUnitType(unitType: ScheduleTypeEnum) {
    this.selectedUnitType = unitType;
    this.showUnitTypeOptions = false;
    this.newScheduleData = this.initializeNewScheduleData();
    this.newScheduleData.scheduleType = this.selectedUnitType;
    this.newScheduleData.tenure =
      this.selectedUnitType == ScheduleTypeEnum.Flat ? TenureEnum.Leasehold : TenureEnum.Freehold;
  }

  addnewScheduleData() {
    this.dealScheduleClient.addUpdate(this.newScheduleData).then((newScheduleData) => {
      this.scheduleData.push(newScheduleData);
      this.prepareUnitData();
      this.newScheduleData = {
        dealId: this.dealDto.id,
      } as DealSchedule;
      this.developmentScheduleForm.$setPristine();
      this.showUnitTypeOptions = false;
      this.selectedUnitType = null;
    });
  }

  updateSelectedScheduleData(scheduleRow) {
    this.dealScheduleClient.addUpdate(scheduleRow).then((scheduleRow) => {
      this.calculateScheduleUnitsTotalGDVAndArea();
    });
  }

  deleteSelectedScheduleData() {
    this.dataLoading = true;
    this.showScheduleUnitDeleteConfirmation = false;
    this.dealScheduleClient
      .markAsDeleted(this.tempScheduleData.id)
      .then((response) => {
        this.scheduleData = this.scheduleData.filter((s) => s.id != this.tempScheduleData.id);
        this.prepareUnitData();
      })
      .catch((error) => {
        this.showMessage("Sorry, something went wrong. Please try again.");
        this.showSuccessorFailureMessage = true;
      })
      .finally(() => {
        this.tempScheduleData = null;
        this.dataLoading = false;
      });
  }

  closeAddSchduleDataForm() {
    this.showUnitTypeOptions = false;
    this.selectedUnitType = null;
    this.newScheduleData = this.initializeNewScheduleData();
  }

  getTenureText(tenureValue) {
    var value = null;
    switch (tenureValue) {
      case TenureEnum.Freehold:
        value = "Freehold";
        break;
      case TenureEnum.Leasehold:
        value = "Leasehold";
        break;
      case TenureEnum.Other:
        value = "Other";
        break;
      default:
        break;
    }
    return value;
  }

  calculatePricePerUnit(scheduleRow) {
    if (scheduleRow.salesPrice != null && scheduleRow.area != null) {
      return Number(scheduleRow.salesPrice) / scheduleRow.area;
    } else {
      return 0;
    }
  }

  getDescriptionText(description) {
    let value = null;
    switch (description) {
      case ScheduleDescriptionTypeEnum.Bungalow:
        value = "Bungalow";
        break;
      case ScheduleDescriptionTypeEnum.Cottage:
        value = "Cottage";
        break;
      case ScheduleDescriptionTypeEnum.DetachedHouse:
        value = "Detached house";
        break;
      case ScheduleDescriptionTypeEnum.SemiDetachedHouse:
        value = "Semi-detached house";
        break;
      case ScheduleDescriptionTypeEnum.TerrancedHouse:
        value = "Terranced house";
        break;
      case ScheduleDescriptionTypeEnum.Duplex:
        value = "Duplex";
        break;
      case ScheduleDescriptionTypeEnum.SingleStorey:
        value = "Single storey";
        break;
      case ScheduleDescriptionTypeEnum.Triplex:
        value = "Triplex";
        break;
      case ScheduleDescriptionTypeEnum.Studio:
        value = "Studio";
        break;
      default:
        break;
    }
    return value;
  }

  getSelectedUnitTypeText(scheduleUnit) {
    let value = null;
    switch (scheduleUnit) {
      case ScheduleTypeEnum.Commercial:
        value = "Commercial";
        break;
      case ScheduleTypeEnum.House:
        value = "Houses";
        break;
      case ScheduleTypeEnum.Flat:
        value = "Flats";
        break;
      default:
        break;
    }
    return value;
  }

  getPreAgreementText(preAgreementType) {
    let value = null;
    switch (preAgreementType) {
      case PreAgreementEnum.PreLet:
        value = "Pre-let";
        break;
      case PreAgreementEnum.PreSold:
        value = "Pre-sold";
        break;
      case PreAgreementEnum.None:
        value = "None";
        break;
      default:
        break;
    }

    return value;
  }

  prepareUnitData() {
    this.calculateScheduleUnitsTotalGDVAndArea();
    this.houses = this.scheduleData.filter((s) => s.scheduleType == ScheduleTypeEnum.House);
    this.parking = this.scheduleData.filter((s) => s.scheduleType == ScheduleTypeEnum.Parking);
    this.flats = this.scheduleData.filter((s) => s.scheduleType == ScheduleTypeEnum.Flat);
    this.commercial = this.scheduleData.filter((s) => s.scheduleType == ScheduleTypeEnum.Commercial);
  }

  getHouseOrFlatDescriptionOptions(selectedUnitType) {
    if (selectedUnitType == ScheduleTypeEnum.House) {
      return this.houseDescriptionTypeOptions;
    }

    if (selectedUnitType == ScheduleTypeEnum.Flat) {
      return this.flatDescriptionTypeOptions;
    }
  }

  calculateScheduleUnitsTotalGDVAndArea() {
    if (this.scheduleData.length > 0) {
      if (this.dealDto.endPropertyType == PropertyTypeEnum.Residential) {
        this.totalScheduleUnitsGDV = this.scheduleData
          .filter((s) => s.scheduleType == ScheduleTypeEnum.House || s.scheduleType == ScheduleTypeEnum.Flat)
          .map((i) => Number(i.salesPrice))
          .reduce((a, b) => a + b, 0);
        this.totalScheduleUnitsArea = this.scheduleData
          .filter((s) => s.scheduleType == ScheduleTypeEnum.House || s.scheduleType == ScheduleTypeEnum.Flat)
          .map((i) => Number(i.area))
          .reduce((a, b) => a + b, 0);
      } else if (
        this.dealDto.endPropertyType == PropertyTypeEnum.MixedUse ||
        this.dealDto.endPropertyType == PropertyTypeEnum.HMO
      ) {
        this.totalScheduleUnitsGDV = this.scheduleData.map((i) => Number(i.salesPrice)).reduce((a, b) => a + b, 0);
        this.totalScheduleUnitsArea = this.scheduleData.map((i) => Number(i.area)).reduce((a, b) => a + b, 0);
      } else {
        this.totalScheduleUnitsGDV = this.scheduleData
          .filter((s) => s.scheduleType == ScheduleTypeEnum.Commercial)
          .map((i) => Number(i.salesPrice))
          .reduce((a, b) => a + b, 0);
        this.totalScheduleUnitsArea = this.scheduleData
          .filter((s) => s.scheduleType == ScheduleTypeEnum.Commercial)
          .map((i) => Number(i.area))
          .reduce((a, b) => a + b, 0);
      }
    }
  }

  onClickOfEditScheduleData(selectedRow) {
    this.tempScheduleData = { ...selectedRow };
  }

  onClickOfDeleteScheduleData(selectedRow) {
    this.tempScheduleData = { ...selectedRow };
    this.showScheduleUnitDeleteConfirmation = true;
  }

  getFilesByModule(module) {
    if (module == ModuleEnum.Track) {
      return this.fileUpload.filter((item) => item.module === module && item.dealClientId == this.currentApplicant.id);
    } else {
      return this.fileUpload.filter((item) => item.module === module);
    }
  }

  isPropertySectionValid() {
    let message = "";
    this.isPropertySectionInvalidToSave = false;
    if (this.propertyDetailsForm && this.propertyDetailsForm.$dirty && this.propertyDetailsForm.$invalid) {
      message = "Property";
      this.isPropertySectionInvalidToSave = true;
    }

    if (this.buildCostsForm && this.buildCostsForm.$dirty && this.buildCostsForm.$invalid) {
      message = message ? `${message} , Build Costs` : "Build Costs";
      this.isPropertySectionInvalidToSave = true;
    }

    if (this.salesForm && this.salesForm.$dirty && this.salesForm.$invalid) {
      message = message ? `${message} , Sales` : "Sales";
      this.isPropertySectionInvalidToSave = true;
    }

    if (this.planningForm && this.planningForm.$dirty && this.planningForm.$invalid) {
      message = message ? `${message} , Planning` : "Planning";
      this.isPropertySectionInvalidToSave = true;
    }

    if (this.buildProcurementForm && this.buildProcurementForm.$dirty && this.buildProcurementForm.$invalid) {
      message = message ? `${message} , Build Procurement` : "Build Procurement";
      this.isPropertySectionInvalidToSave = true;
    }

    return `Please correct values in ${message} section.`;
  }

  updateGDV() {
    //Storing a below value so that we can revert the values on dealDto when addUpdatereturnonlyid fails.
    this.tempGDV = this.dealDto.gdv;
    this.tempAreaAcquisition = this.dealDto.areaAcquisition;
    this.dealDto.gdv = this.totalScheduleUnitsGDV;
    this.updateDealDto("GDV has been updated successfully");
  }

  updateGIAToTotalScheduleUnitsArea() {
    //Storing a below value so that we can revert the values on dealDto when addUpdatereturnonlyid fails.
    this.tempGDV = this.dealDto.gdv;
    this.tempAreaAcquisition = this.dealDto.areaAcquisition;
    this.dealDto.areaAcquisition = this.totalScheduleUnitsArea;
    this.updateDealDto("Area/GIA has been updated successfully");
  }

  updateHasPropertyScheduleBreakdownVal() {
    this.dataLoading = false;
    this.developmentFinanceCrudDealClient
      .patch({
        id: this.dealDto.id,
        hasPropertyScheduleBreakdown: this.dealDto.hasPropertyScheduleBreakdown,
      })
      .then(() => { })
      .catch((error) => {
        this.showMessage("Sorry, something went wrong. Please try again.");
        this.showSuccessorFailureMessage = true;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  updateDealDto(successmessage: string = "") {
    this.dataLoading = false;
    this.developmentFinanceDealClient
      .addUpdateReturnOnlyID(this.dealDto)
      .then((dealId) => {
        if (successmessage.length > 0) {
          this.showMessage(successmessage);
          this.showSuccessorFailureMessage = true;
        }
      })
      .catch((error) => {
        if (successmessage.length > 0) {
          this.dealDto.gdv = this.tempGDV;
          this.dealDto.areaAcquisition = this.tempAreaAcquisition;
        }
        this.showMessage("Sorry, something went wrong. Please try again.");
        this.showSuccessorFailureMessage = true;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  updateClassUses() {
    if (this.dealDto.classUses > 0) {
      for (let i = 1; i < this.dealDto.classUses; i *= 2) {
        if (this.dealDto.classUses >= i) {
          //number is in enum sum, add it to object
          if (this.dealDto.classUses & i) {
            this.classUses[i] = true;
          }
        }
      }
    }

    //watch and update classuses
    this.$scope.$watchCollection("ctrl.classUses", (newVal: {}) => {
      let valuesList = Object.keys(newVal);
      let total: number = 0;
      //tot up all the numeric keys (class use enums)
      valuesList.forEach((v, i) => {
        let keyToNum = Number(v);
        if (newVal[keyToNum]) {
          total += keyToNum;
        }
      });
      this.dealDto.classUses = total;
    });
  }

  getOrganisationbyDealId() {
    this.organisationClient.getOrganisationAndBrokerByDealId(this.dealDto.id).then((response) => {
      this.org = response.organisation;
      this.dealBrokerUser = response.broker;
      this.brokerCommission =
        this.dealDto.status == CaseStatusEnum.NewCase
          ? this.org?.commissionPercent
          : this.dealDto.brokerCommissionPercent;
      this.brokerPreferredContact =
        this.dealDto.status == CaseStatusEnum.NewCase ? response.broker.phoneNumber : this.dealDto.brokerPhoneNumber;
      if (this.org.isWhiteLabelled) {
        this.fileNamePrefix = this.org.name.replace(/ /g, "_");
      } else {
        this.fileNamePrefix = "Brickflow";
      }
    });
  }

  getOwnershipPercentageText() {
    if (this.dealDto != null) {
      return this.sharedDealService.getOwnershipPercentageText(this.currentApplicant, this.dealDto.productType);
    }
    return "Shareholding";
  }

  closeSubmitToLenderModal() {
    this.showTsAndCs = false;
    this.brokerCommission =
      this.dealDto.status == CaseStatusEnum.NewCase
        ? this.org?.commissionPercent
        : this.dealDto.brokerCommissionPercent;
    this.brokerPreferredContact =
      this.dealDto.status == CaseStatusEnum.NewCase ? this.dealBrokerUser?.phoneNumber : this.dealDto.brokerPhoneNumber;
    this.isBrokerPhoneNumberUpdated = false;
  }

  isCompanyAndOwnershipSaveDisabled() {
    return this.dealDto.howWillYouOwnNewDevelopment == null || this.dealDto.howWillYouOwnNewDevelopment <= 0
      ? true
      : false;
  }

  showBasedOnMainResidence() {
    return DealHelper.showBasedOnMainResidence(this.dealDto);
  }

  checkBrokerDeal() {
    return this.dealDto?.brokerUserId != null && this.isClient ? true : false;
  }

  goToUserDashboardEquityAndMezz() {
    this.userDashboardService.setGoToNavMenu(5);
    this.$location.path("/userdashboard");
  }

  hasMaximumApplicants() {
    return this.applicantList.filter((a) => a.isApplicant).length >= 4 ? true : false;
  }

  getRequiredRolesOptions() {
    return DealHelper.getRequiredRolesOptions(true, this.isReadOnlyDeal);
  }

  logExportDownload(eventName) {
    this.eventLogClient.logEvent(eventName, EventLogEnum.Export, this.dealDto.productType, this.dealDto.id);
  }

  getTinymceOptions = function () {
    return this.isLender || this.isReadOnlyDeal ? this.tinymceReadonlyOptions : this.tinymceOptions;
  };

  initializeNewScheduleData() {
    return {
      description: ScheduleDescriptionTypeEnum.DetachedHouse,
      bedCount: 0,
      tenure: TenureEnum.Freehold,
      salesPrice: 0,
      area: 0,
      preAgreement: PreAgreementEnum.None,
      annualRent: 0,
      scheduleType: ScheduleTypeEnum.House,
      deal: null,
      id: 0,
      dealId: this.dealDto.id,
      isDeleted: false,
      createdDateTime: null,
      lastUpdatedDateTime: null,
      lastModifiedUser: null,
      lastModifiedUserId: null,
      createdUserId: null,
      createdUser: null,
    };
  }

  async loadUserRolesAndDealIntegration() {
    await this.getCurrentUserAndRoles();

    if (this.isBroker || this.isAdmin) {
      this.organisationClient.getOrganisationProductAccess().then((response) => {
        this.isDeallockerIntegrationEnabled = response.isDeallockerIntegrationEnabled;
      });
    }
  }
}
